import { render, staticRenderFns } from "./FriendInviteRedeemDialog.vue?vue&type=template&id=63630823&scoped=true"
import script from "./FriendInviteRedeemDialog.vue?vue&type=script&lang=js"
export * from "./FriendInviteRedeemDialog.vue?vue&type=script&lang=js"
import style0 from "./FriendInviteRedeemDialog.vue?vue&type=style&index=0&id=63630823&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63630823",
  null
  
)

export default component.exports